import React, { Fragment } from 'react';
import classNames from 'classnames';
import { BarsSolidIcon } from 'components/icons';
import DeviceChartCard from './DeviceChartCard';
import DeviceChartMenuBar from './DeviceChartMenuBar';
import styles from './DeviceChartPlaceholderCard.module.css';

function DeviceChartPlaceholderCard({ name, classes, onEdit, onChange }) {
  return (
    <DeviceChartCard.Container className={classes?.container}>
      <DeviceChartCard.Header className={classes?.header}>
        <DeviceChartMenuBar
          name={name}
          title="Select a chart"
          onChange={onChange}
          actions={
            <Fragment>
              <button onClick={onEdit}>Edit</button>
            </Fragment>
          }
        />
      </DeviceChartCard.Header>
      <DeviceChartCard.Body className={classes?.body}>
        <div className={classNames(styles.root)}>
          <div className={classNames(styles.container, classes?.placeholderContainer)}>
            <BarsSolidIcon className={styles.icon} />
            <span className={classNames(styles.message)}>Select a chart to display</span>
          </div>
        </div>
      </DeviceChartCard.Body>
    </DeviceChartCard.Container>
  );
}

export default DeviceChartPlaceholderCard;
